import script from "./promptList.vue?vue&type=script&setup=true&lang=ts"
export * from "./promptList.vue?vue&type=script&setup=true&lang=ts"

import "./promptList.vue?vue&type=style&index=0&id=6ac3ac88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac3ac88"]])

export default __exports__